module.exports = __webpack_public_path__ + "static/an-14951c5e30f87b8cdef7ffefaa503748.png";